import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'renewed-token',
    templateUrl: './renewed-token.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RenewedTokenComponent {}